import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import {FormattedMessage} from 'react-intl';

class Countdown extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.getCountdown = this.getCountdown.bind(this);

        this.state = {
            countdown: null
        };
    }

    componentDidMount() {
        if (this.props.time && moment(this.props.time).isValid()) {
            this.countdownInterval = setInterval(this.getCountdown, 1000);
        }
    }

    componentWillUnmount() {
        clearInterval(this.countdownInterval);
    }

    getCountdown() {
        const diff = moment(this.props.time).diff(moment(), 'seconds');
        if (diff < 0) {
            clearInterval(this.countdownInterval);
            this.setState({countdown: null});
        } else {
            const days = Math.floor(diff / 86400);
            const hours = Math.floor((diff % 86400) / 3600);
            const minutes = Math.floor((diff % 3600) / 60);
            const seconds = diff % 60;
            this.setState({
                countdown: {
                    days: days >= 10 ? days : `0${days}`,
                    hours: hours >= 10 ? hours : `0${hours}`,
                    minutes: minutes >= 10 ? minutes : `0${minutes}`,
                    seconds: seconds >= 10 ? seconds : `0${seconds}`
                }
            });
        }
    }

    render() {
        return (
            <div>
                {do {
                    if (this.state.countdown) {
                        <div className="countdown-container">
                            <div className="countdown">
                                <div>{this.state.countdown.days}</div>
                                <FormattedMessage id="countdown.days"/>
                            </div>
                            <div className="countdown">
                                <div>{this.state.countdown.hours}</div>
                                <FormattedMessage id="countdown.hours"/>
                            </div>
                            <div className="countdown">
                                <div>{this.state.countdown.minutes}</div>
                                <FormattedMessage id="countdown.minutes"/>
                            </div>
                            <div className="countdown">
                                <div>{this.state.countdown.seconds}</div>
                                <FormattedMessage id="countdown.seconds"/>
                            </div>
                        </div>;
                    }
                }}
            </div>
        );
    }
}

Countdown.propTypes = {
    time: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ])
};

export default Countdown;


// WEBPACK FOOTER //
// ./src/components/common/Countdown.js